<h2>Application details</h2>
<div class="row">
  <div class="col-md-4">
    <div class="form-group">
      <label>Applicant number</label>
      <div type="text" class="form-control readonly" [innerHTML]="application.preregNumber"></div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Applicant name</label>
      <div type="text" name="reg" class="form-control readonly" [innerHTML]='application.name'></div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Date Submitted</label>
      <div type="text" class="form-control readonly" [innerHTML]="(application.submittedDate | date:'dd/MM/yyyy') || '-'"></div>
    </div>
  </div>
  @if (application?.clinicalSpecialities) {
    <div class="col-md-4">
      <div class="form-group">
        <label>Clinical Speciality</label>
        <div type="text" class="form-control readonly" [innerHTML]="$safeNavigationMigration(application?.clinicalSpecialities)"></div>
      </div>
    </div>
  }
</div>

@if (hasPlacements && !isPreRegVersionNew) {
  <div>
    <h2 class="mb-4">
      Training scheme details
    </h2>
    <div class="row">
      @for (trainingSite of trainingSites; track trainingSite) {
        <div class="col-md-12">
          <h4>{{ trainingSite.premise.name  }}</h4>
          <div class="form-group">
            <label>Are you an owner or director of, or a majority shareholder in, this pharmacy?</label>
            <div type="text" class="form-control readonly">{{trainingSite.isOwner | friendlyBoolean }}</div>
          </div>
          <div class="form-group">
            <label>Are you related to a director of this pharmacy, or do you have a ‘significant relationship’
            with a director or employee of this pharmacy?</label>
            <div type="text" class="form-control readonly">{{trainingSite.isRelated | friendlyBoolean }}</div>
          </div>
        </div>
      }
    </div>
  </div>
}

@if (isPreRegVersionNew) {
  <div>
    <h2>
      Training scheme details
    </h2>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Oriel Scheme Number</label>
          <div type="text" class="form-control readonly" [innerHTML]="(application?.orielSchemeNumber || '-')"></div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>SEB</label>
          <div type="text" class="form-control readonly" [innerHTML]="(userSEBType || '-')"></div>
        </div>
      </div>
    </div>
  </div>
}